import { Component, h, ComponentInterface, State, Prop, Listen } from '@stencil/core';
import { guid } from 'utils';


@Component({
  tag: 'kdx-input-check',
  styleUrl: 'kdx-input-check.scss',
  shadow: false
})
export class StInputCheck implements ComponentInterface {

  @State() guid: string = `kdx-input-check-${guid()}`;

  @Prop() isInline?: boolean;

  @Prop() label: string;
  @Prop() isCategory?: boolean;
  @Prop() filterUrl :string;

  private isSelected:boolean = false;

  componentWillLoad(){
    if(!this.filterUrl)
      return;
    if(this.filterUrl == window.location.href){
      this.isSelected = true;
    }
  }

  @Listen('click')
  filterCategory(e:Event)
  {
   if(!(e as KeyboardEvent) || !(e as MouseEvent))
    return;

    if(e as KeyboardEvent){
      if((e as KeyboardEvent).key == " " || (e as KeyboardEvent).key == "Enter"){
        e.preventDefault();
        (e.target as HTMLInputElement).checked = true;
      }
    }

    if(!this.filterUrl)
      return;

    window.location.href = this.filterUrl;
  }
   

  render(){
    return (
      <div class={`form-check${(this.isInline) ? ' form-check-inline' : ''}${(this.isCategory)? ' category-item':''}`}
      onClick={this.filterCategory} 
      onKeyDown={(e) => this.filterCategory(e)}>
        <input class="form-check-input" type="checkbox" value="" id={this.guid} checked={(this.isSelected)?true:false} />
        <label class="form-check-label" htmlFor={this.guid}>{this.label}</label>
      </div>
    );
  }
}